import React, { useContext, useEffect, useRef, useState } from 'react'
import { getImages } from '../../const'
import ModalLayout from '../Component/Common/ModalLayout';
import TripStatsModal from '../Component/Modals/TripStatsModal';
import TripFullMap from '../Component/TripMap/TripFullMap';
import { TripContext } from '../Context/TripContext';
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TripDetails from '../Component/TripMap/TripDetails';
import TopActions from '../Component/TripMap/TopActions';
import PromotMode from '../Component/TripMap/PromotMode';
import { Link } from 'react-router-dom';
import ImageCropModal from '../Component/Modals/ImageCropModal';
import MenuList from '../Component/Common/MenuList';

const TripMap = () => {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyBqO4KEs8WZww5A41ie8znHO3SI37ov7iM",
        libraries: ["geometry", "drawing", "places"]
    });
    const { tripData, generateTrip, tripLoading } = useContext(TripContext);

    const [openTripStatsModal, setOpenTripStatsModal] = useState(false);
    const handleTripStats = () => {
        setOpenTripStatsModal(true);
    }
    const closeTripStatsModal = () => {
        setOpenTripStatsModal(false);
    }

    const [tripInputData,setTripInputData] = useState({
        destination:tripData?.destination || "",
        num_parks:tripData?.num_parks || "1",
        origin:tripData?.origin || "",
        scenic_mode:tripData?.scenic_mode,
        // trip_length:tripData?.trip_length || "",
        stop_location:tripData?.stop_location || "",
        trip_type:tripData?.trip_type || "one-way",
    });
    //console.log("tripInputData", tripInputData)
    const [extraFields, setExtraFields] = useState("");
    //console.log("extraFields", extraFields)
    const updateTripData = (e) => {
        setTripInputData({ ...tripInputData, [e.target.name]: e.target.value });
    }
    const trackedFields = ["trip_type", "num_parks", "scenic_mode"];
    const updateTripDataField = (field, value) => {
        setTripInputData({ ...tripInputData, [field]: value });
        if (trackedFields.includes(field)) {
            setExtraFields({ ...tripInputData, [field]: value });
        }
    }

    const tripSubmit = (e) => {
        e.preventDefault();

        console.log(tripInputData);

        generateTrip(tripInputData);
    }
    useEffect(() => {
        if (extraFields) {
            generateTrip(extraFields);
        }
    }, [extraFields]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 991);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 991);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    // Mobile menu state
    const [isMob, setisMob] = useState(false);
    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };
     const closeMenu = () => {
        setisMob(false);
        // setOpenSubMenu(false);
        document.body.classList.remove('overflow-active');
    }
    // Mobile Tabs 
    const [active, setActive] = useState("route");

    const [showCrop, setShowCrop] = useState(false);
    const [imageSrc, setImageSrc] = useState(null);
    const [selectedImages, setSelectedImages] = useState([]);
    //console.log("selectedImages", selectedImages)
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        const imageUrl = URL.createObjectURL(file);

        setImageSrc(imageUrl);
        setShowCrop(true);
    };
    const handleCropComplete = (croppedImage) => {
        setSelectedImages((prev) => [...prev, croppedImage]);
        setShowCrop(false);
    };
    const closeCropModal = () => {
        setShowCrop(false);
    }
    if (!isLoaded) return <div>Loading...</div>;
    return (
        <>
            {!isMobile ?
                <div className='main-wrap d-flex'>
                    <TripDetails
                        setTripInputData={setTripInputData}
                        updateTripData={updateTripData}
                        updateTripDataField={updateTripDataField}
                        tripSubmit={tripSubmit}
                        tripInputData={tripInputData}
                        setExtraFields={setExtraFields}
                    />
                    <div className='main-right'>
                        {!tripLoading ? 
                        <>
                            <div className='dash-header d-flex align-items-center justify-content-end'>
                                <div className='me-4'>
                                    <button className='transparent-btn d-flex align-items-center' type='button'>
                                        <span className='icon-directions font-20 text-orange me-2'></span>
                                        <div className='xss-title'>My Trips</div>
                                    </button>
                                </div>
                                <div className="dropdown user-menu">
                                    <button
                                        className="btn d-flex align-items-center gap-2 dropdown-toggle"
                                        type="button"
                                    >
                                        <img
                                            src="https://i.pravatar.cc/50"
                                            alt="user"
                                            className="rounded-circle"
                                            width="32"
                                            height="32"
                                        />
                                        <span className="xss-title">My Account</span>
                                    </button>
                                    {/* <button
                                        className="btn d-flex align-items-center gap-2 dropdown-toggle"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <img
                                            src="https://i.pravatar.cc/50"
                                            alt="user"
                                            className="rounded-circle"
                                            width="32"
                                            height="32"
                                        />
                                        <span className="xss-title">My Account</span>
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end shadow">
                                        <li>
                                            <a className="dropdown-item" href="#">
                                                👤 Profile
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" href="#">
                                                ⚙️ Settings
                                            </a>
                                        </li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li>
                                            <a className="dropdown-item text-danger" href="#">
                                                🚪 Logout
                                            </a>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                            <div className='mr-mid-area'>
                                <TripFullMap isLoaded={isLoaded} tmHeight="calc(100vh - 55px)" tripInputData={tripInputData}/>
                                <TopActions handleTripStats={handleTripStats} />
                            </div>
                        </> : 
                        <>
                        <div className='mr-block-loading'>
                            <div className='mrl-pos'>
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden"></span>
                                </div>
                                <div className='ms-2'>Loading</div>
                                </div>
                            </div>
                        </>}
                    </div>
                </div> :
                <div className='main-wrap'>
                    <div className='tm-header-wrap'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='main-logo'>
                                <Link to='/'><img src={getImages('WeGoScenic-logo.png')} /></Link>
                            </div>
                            <div className={`position-relative ms-xl-5 ps-xl-5 main-menu ${isMob ? 'active' : ''}`}>
                                <MenuList closeMenu={closeMenu}/>
                            </div>
                            <div className={`overflow-bg d-xl-none ${isMob ? 'active' : ''
                                }`} onClick={() => onChangeBodyClass(!isMob)}></div>
                            <div
                                className={`mobile-inner-header ms-3 d-xl-none ${isMob ? 'active' : ''}`}
                                onClick={() => onChangeBodyClass(!isMob)}
                            >
                                <div
                                    className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                        }`}
                                >
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`mr-mid-area ${active === "route" ? 'active' : ''}`}>
                        <TripFullMap isLoaded={isLoaded} tmHeight="calc(100vh - 132px)" />
                        {active === "route" && (
                            <TopActions handleTripStats={handleTripStats} />
                        )}
                        {active === "trip" && (
                            <div className="td-area">
                                <TripDetails
                                    setTripInputData={setTripInputData}
                                    updateTripData={updateTripData}
                                    updateTripDataField={updateTripDataField}
                                    tripSubmit={tripSubmit}
                                    tripInputData={tripInputData}
                                    setExtraFields={setExtraFields}
                                    tmHeight="calc(100vh - 132px)"
                                />
                            </div>
                        )}
                        {/* {active === "prompt" && (
                            <div className='main-left' style={{ height: "calc(100vh - 132px)" }}>
                                <div className='ml-block px-3 pb-0' style={{ height: "100%" }}>
                                    <div className='position-relative' style={{ height: "100%" }}>
                                        <PromotMode />
                                    </div>
                                </div>
                            </div>
                        )} */}
                    </div>
                    <div className='d-flex align-items-center tm-mob-actions'>
                        <div
                            className={`tmm-col text-center ${active === "route" ? "active" : ""}`}
                            onClick={() => setActive("route")}
                        >
                            <div>
                                <div><span className="icon-map text-white"></span></div>
                                <div className='xss-title text-white font-12 fw-400'>Route</div>
                            </div>
                        </div>
                        <div
                            className={`tmm-col text-center ${active === "trip" ? "active" : ""}`}
                            onClick={() => setActive("trip")}
                        >
                            <div>
                                <div><span className="icon-location-pin text-white"></span></div>
                                <div className='xss-title text-white font-12 fw-400'>Trip Details</div>
                            </div>
                        </div>
                        <div
                            className={`tmm-col text-center ${active === "prompt" ? "active" : ""}`}
                            onClick={() => setActive("prompt")}
                        >
                            <div>
                                <div><span className="icon-bubble text-white"></span></div>
                                <div className='xss-title text-white font-12 fw-400'>Prompt Mode</div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {openTripStatsModal && (
                <ModalLayout open={openTripStatsModal} close={closeTripStatsModal} darkThemeCls='true' modalWidth={1000}>
                    <TripStatsModal 
                        close={closeTripStatsModal} 
                        handleImageChange={handleImageChange}
                        selectedImages={selectedImages}
                        setSelectedImages={setSelectedImages}
                        setImageSrc={setImageSrc} 
                        setShowCrop={setShowCrop}
                    />
                </ModalLayout>
            )}
            
            {showCrop && (
                <ModalLayout open={showCrop} close={closeCropModal} darkThemeCls='true' modalWidth={1000}>
                    <ImageCropModal
                        image={imageSrc}
                        onClose={() => setShowCrop(false)}
                        onCrop={handleCropComplete}
                         close={closeCropModal}
                    />
                </ModalLayout>
            )}
        </>
    )
}

export default TripMap